import React from 'react';

const LogoEFiling = ({ className = "w-12 h-12" }) => (
  <svg className={className} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="12" fill="#7C3AED"/>
    <path d="M14 12H26L34 20V36H14V12Z" fill="white"/>
    <path d="M26 12V20H34" fill="#E5E7EB"/>
    <path d="M18 26H30" stroke="#7C3AED" strokeWidth="2" strokeLinecap="round"/>
    <path d="M18 30H26" stroke="#7C3AED" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export default LogoEFiling;
